import { User } from '../../../models/User';
import { UntypedFormControl, UntypedFormGroup, UntypedFormArray } from '@angular/forms';

declare const $: any;

export function getNumberFromInput(input: any): number {
  if ((input == null) || input.length === 0) {
    return null;
  }

  return +input || 0;
}

export function getFloatFromInput(input: any): number {
  // Only keep numbers and periods from input and convert to float
  if ((input == null) || input.length === 0) {
    return null;
  }
  if (typeof input === 'number') {
    return input;
  }

  return parseFloat(input.toString().replace(/[^\d.]/g, ''));
}

export function isInputFilledNumber(input: any): boolean {
  return input !== undefined && input !== null && input !== '' && !isNaN(Number(input));
}

export function responseToFormElement(survey, key, validators = []): FormElement {
  if (survey[key] != null) {
      return {
      lastUpdated: new Date(survey[key].lastUpdatedDate),
      lastUpdatedUser: survey[key].lastUpdatedUser,
      updatedBySRAdmin: survey[key].updatedBySRAdmin,

      valueControl: new UntypedFormControl(survey[key].value, validators),
      markAsUpdatedControl: new UntypedFormControl(false),
    };
  }

  return {
    lastUpdated: null,
    lastUpdatedUser: null,
    updatedBySRAdmin: null,

    valueControl: new UntypedFormControl(null, validators),
    markAsUpdatedControl: new UntypedFormControl(false),
  };
}

/**
 * Adjusts modal content height and positioning based on the
 * header and footer height, in order to support dynamically
 * long header text
 * @param inputModal The modal to adjust
 */
export function adjustModalContent(inputModal: HTMLElement) {
  let header: HTMLElement | null = null;
  let content: HTMLElement | null = null;
  let footer: HTMLElement | null = null;

  // Unwrap modal child elements if needed (for DSS)
  const modal: HTMLElement = inputModal.childElementCount === 1
    ? (inputModal.children[0] as HTMLElement)
    : inputModal;

  // Loop only through ELEMENT nodes
  const childNodes = Array.from(modal.children);
  childNodes.forEach((node) => {
    const element = node as HTMLElement;
    if (element.classList.contains('modal-header')) {
      header = element;
    } else if (element.classList.contains('modal-content')) {
      content = element;
    } else if (element.classList.contains('modal-footer')) {
      footer = element;
    }
  });

  // If elements exist, adjust content height appropriately
  if (header && content && footer) {
    const offsetHeight = header.offsetHeight + footer.offsetHeight;
    const offsetTop = header.offsetHeight;
    content.setAttribute('style', `height: calc(100% - ${offsetHeight}px); top: ${offsetTop}px;`);
  }

  inputModal.querySelectorAll<HTMLTextAreaElement>('textarea.materialize-textarea').forEach((textarea) => {
    $(textarea).trigger('autoresize');
  });
}

export interface FormElement {
  lastUpdated: Date;
  lastUpdatedUser: User;
  updatedBySRAdmin: boolean;

  valueControl: UntypedFormControl | UntypedFormGroup | UntypedFormArray;
  markAsUpdatedControl: UntypedFormControl;
}

export interface ReportFrequency {
  id: number;
  displayName: string;
}

export const REPORT_SUBMISSION_FREQUENCY: ReportFrequency[] = [
  {
    id: 0,
    displayName: 'Daily',
  },
  {
    id: 1,
    displayName: 'Weekly',
  },
  {
    id: 2,
    displayName: 'Monthly',
  },
  {
    id: 3,
    displayName: 'Quarterly',
  },
  {
    id: 4,
    displayName: 'Annually',
  },
  {
    id: 5,
    displayName: 'Other',
  },
];
